import StackRouter from './StackRouter'

export default StackRouter
